export const to2DecimalDigits = (amount: number): string => {
  return (amount / 100).toFixed(2);
};

